import React, { useEffect, useState } from "react";
import {
  RiHome4Line
} from "react-icons/ri";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi/";
import {
  Sidebar,
  SubMenu,
  Menu,
  MenuItem
} from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getModules } from "../../redux/userDataSlice";
import BarLoader   from "react-spinners/BarLoader";

function Sidebars() { 
  const dispatch = useDispatch();
  const state = useSelector(state => state);

  useEffect(() => {
    dispatch(getModules());
  }, []);

  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  // Responsive sidebar toggle
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1500) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Sidebar
        className={`app ${toggled ? "toggled" : ""} h-full bg-white`}
        backgroundColor="white"
        collapsed={collapsed}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
        handleCollapsedChange={handleCollapsedChange}
      >
        <main>
          <Menu>
            {collapsed ? (
              <MenuItem
                icon={<FiChevronsRight />}
                onClick={handleCollapsedChange}
              ></MenuItem>
            ) : (
              <MenuItem
                suffix={<FiChevronsLeft />}
                onClick={handleCollapsedChange}
              >
                <h1 className="ml-[15px] font-medium text-gray-500" style={{color: "gray" }}>
                  <i style={{ color: "#0766AD" }} className="fa-solid fa-bars mr-3"></i>
                  Menü
                </h1>
              </MenuItem>
            )}
            <hr />
          </Menu>

          {!state.isLoading ? (
            <Menu>
              <Link style={{ color: "#6DB9EF" }} to={"/dashboards"}>
                <MenuItem style={{ fontWeight: "500" }} icon={<RiHome4Line color="#6DB9EF" size={20} />}>
                  Anasayfa
                </MenuItem>
              </Link>
              {state.userModules?.map((item, index) => (
                item.rolesModulesSub?.length ? (
                  <SubMenu 
                  style={{ color: "gray", fontWeight: "500" }}
                    key={index} 
                    label={item.moduleName} 
                    icon={<i style={{ color: "#0766AD" }} className={`${item.icon}`}></i>}
                  >
                    {item.rolesModulesSub.map((subItem, subIndex) => (
                      <Link to={subItem.moduleLink} key={subIndex}>
                        <MenuItem 
                          style={{ color: "gray", fontWeight: "500" }} 
                          icon={<i style={{ color: "#0766AD" }} className={`${subItem.icon}`}></i>}
                        >
                          {subItem.moduleName}
                        </MenuItem>
                      </Link>
                    ))}
                  </SubMenu>
                ) : (
                  <Link to={item.moduleLink} key={index}>
                    <MenuItem 
                      style={{ color: "gray", fontWeight: "500" }} 
                      icon={<i style={{ color: "#0766AD" }} className={`${item.icon}`}></i>}
                    >
                      {item.moduleName}
                    </MenuItem>
                  </Link>
                )
              ))}
            </Menu>
          ) : (
            <div style={{ 
              display: "grid",
              placeItems: "center",
              alignItems:"center",
              marginTop:"200px"
             }}>
               <BarLoader  
                 color={"blue"}
                 loading={state.isLoading}
                 size={100}
                 aria-label="Loading Spinner"
                 data-testid="loader"
                 speedMultiplier={0.5}
               />
             </div>
          )}
        </main>
      </Sidebar>
    </div>
  );
}

export default Sidebars;
